<template>
  <div class="container_box">
    <Tabs v-model="orderTableStatus" :animated="false" class="tabs_styles" @on-click="changeTab">
      <TabPane v-for="item in stockTabList" :label="item.title" :name="item.value"></TabPane>
    </Tabs>
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-if="orderTableStatus === '0'">
            <FormItem :label="$t('key1004334')" prop="packageOrderStatusList">
              <Select v-model="pageParams.packageOrderStatusList" multiple :placeholder="$t('key1004567')">
                <Option v-for="item in stockOrderStatusList" :key="item.value" :value="item.value">{{ item.title }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol"
            v-if="['0','1', '2'].includes(orderTableStatus)">
            <FormItem :label="$t('key1004555')" prop="outPackageOrderStatusList">
              <Select v-model="pageParams.outPackageOrderStatusList" multiple :placeholder="$t('key1004569')">
                <Option v-for="item in deliveryOrderStatusList" :key="item.value" :value="item.value">{{ item.title }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1004424')" prop="outboundTypes">
              <Select v-model="pageParams.outboundTypes" multiple :placeholder="$t('key1004571')">
                <Option v-for="item in deliveryOrderTypeList" :key="item.value" :value="item.value">{{ item.title }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <dropDownDateTime
              :transfer="false"
              ref="dropDownDateTime"
              :dropDownTimeList="dropDownTimeList"
              :defaultSelectValue="defaultSelectTimeValue"
              @changeInput="changeTimeInput"
              @selectTime="selectTime"
              @resetTime="resetTime">
            </dropDownDateTime>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <dropDownFilter
              :transfer="false"
              ref="dropDownFilter"
              inputType="textarea"
              :selectStyle="{width: '110px'}"
              :dropDownInputList="dropDownInputList"
              :defaultSelectValue="defaultSelectValue"
              @changeInput="changeInput"
              @updateInputValue="updateInputValue">
            </dropDownFilter>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr12">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <!--发起备货-->
      <Button type="primary" class="mr15" v-if="getPermission('packageInfo_createStock')"
        @click="$router.push('/initiateStocking')">{{ $t('key1006862') }}</Button>
      <!--批量发货-->
      <Dropdown transfer @on-click="bulkShipmentBtn" class="mr15"
        v-if="['0','1'].includes(orderTableStatus) && getPermission('wmsPickupOrder_batchDeliver')">
        <Button type="primary">
          <span>{{ $t('key1006863') }}</span>
          <Icon type="ios-arrow-down"></Icon>
        </Button>
        <DropdownMenu slot="list">
          <DropdownItem name="1">{{ $t('key1006864') }}</DropdownItem>
          <DropdownItem name="2">{{ $t('key1006865') }}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <!--导出数据-->
      <Dropdown transfer @on-click="changeExportBtn" class="mr15"
        v-if="getPermission('packageInfo_exportPackageInfoStockOrder')">
        <Button>
          <span>{{ $t('key1003082') }}</span>
          <Icon type="ios-arrow-down"></Icon>
        </Button>
        <DropdownMenu slot="list">
          <DropdownItem name="1">{{ $t('key1003083') }}</DropdownItem>
          <DropdownItem name="2">{{ $t('key1003084') }}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <!--打印配货清单-->
      <Button class="mr15" v-if="getPermission('packageInfo_printPrepareGoodsStock')" @click="printDistributionBtn">{{ $t('key1005337') }}</Button>
      <!--打印YMS条码-->
      <Dropdown transfer @on-click="printBarcodeBtn" class="mr15">
        <Button>
          <span>{{ $t('key1000320') + configCharacters(false) + $t('key1001136') }}</span>
          <Icon type="ios-arrow-down"></Icon>
        </Button>
        <DropdownMenu slot="list">
          <DropdownItem v-for="item in printBarcodeList" :name="item.name"
            v-if="getPermission(item.permissionKey)">{{ item.title }}
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <!--打印配货清单-->
      <Button class="mr15" @click="$refs['importBackupOrder'].initImportBackupOrderData()"
        v-if="getPermission('packageInfo_excelImportStockOrder')">{{ $t('key1006842') }}</Button>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        ref="selection"
        highlight-row
        :loading="tableLoading"
        border
        max-height="450"
        :columns="tableColumns"
        :data="tableData"
        @on-selection-change="tableChange">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <!--导出数据字段弹窗-->
    <exportFieldsModal
      ref="exportFields"
      :exportFieldsTitle="$t('key1003082')"
      paramKeyColums="supplierPackageInfoOrderStockExportColumns"
      :customFieldExportList="customFieldExportList"
      @exportFieldsDataBtn="exportFieldsDataBtn">
    </exportFieldsModal>
    <!--配货清单格式弹窗-->
    <distributionListFormatModal ref="distributionListFormat" @updateSelect="updateSelect"></distributionListFormatModal>
    <!--扫描换单-->
    <scanOrderChangeModal ref="scanOrderChange"></scanOrderChangeModal>
    <!--标记发货弹窗-->
    <logisticsInfoModal ref="logisticsInfo" @updateData="printBoxBtn"></logisticsInfoModal>
    <!--打印箱唛弹窗-->
    <printCaseMarkModal
      ref="printTalg"
      :apiUrl="apiUrl"
      :printUpdate="true"
      service="yms-supplier-service"
      typeTalg="packingManage"
      @printUpdateData="search()">
    </printCaseMarkModal>
    <!--修改备货数量弹窗-->
    <modifyStockQuantityModal ref="modifyStockQuantity" @updateData="pageParamsStatus = true"></modifyStockQuantityModal>
    <!--导入备货单弹窗-->
    <importBackupOrderModal ref="importBackupOrder" @updateData="pageParamsStatus = true"></importBackupOrderModal>
    <!--打印预览YMS面单弹窗-->
    <printPreviewWaybillModal
      :batchPrinting="true"
      :editablePrint="false"
      :printPreviewWaybillTitle="$t('key1006851')"
      ref="printPreviewWaybill"
      @updatePrint="updatePrint"
      printType="supplier_batchPrintingBarcodes"
      :printUrl="printUrl">
    </printPreviewWaybillModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import printCaseMarkModal from "@/components/common/printCaseMarkModal.vue";
import distributionListFormatModal from "@/views/supplier/components/supplierOrder/distributionListFormatModal.vue";
import logisticsInfoModal from "@/components/common/logisticsInfoModal.vue";
import exportFieldsModal from "@/components/common/exportFieldsModal.vue";
import scanOrderChangeModal from "@/views/supplier/components/supplierOrder/scanOrderChangeModal.vue";
import dropDownFilter from "@/components/common/dropDownFilter.vue";
import Mixin from "@/components/mixin/common_mixin";
import api from "@/api";
import dropDownDateTime from "@/components/common/dropDownDateTime.vue";
import modifyStockQuantityModal from "@/views/supplier/components/supplierOrder/modifyStockQuantityModal.vue";
import importBackupOrderModal from "@/views/supplier/components/supplierOrder/importBackupOrderModal.vue";
import {getAllWarehouseData, pageJump, setConfigCharacters, getWarehouseName, getAllCountrysData, getEnumList, getDataSetBatchList} from "@/utils/common";
import printPreviewWaybillModal from "@/components/common/printPreviewWaybillModal.vue";


export default {
  name: "stockList",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      total: 0,
      pageParamsStatus: false,
      orderTableStatus: '0',
      pageParams: {
        packageOrderStatusList: [], // 备货单状态 1:待发货 2:已发货 21:已入库 3:已分拣(YMS已收货) 4:已取消
        outPackageOrderStatusList: [], // 出库单状态 1:待发货/待拣货 2:待包装 3:待出库 4:已出库 7:已作废 8:已装箱
        outboundTypes: [], // 出库单类型 (1:销售出库 2:自有仓备货(云卖中心仓备货) 3:三方仓备货(第三方仓备货))
        packageCodeList: '', // 备货单号
        skuList: '', //sku
        ymsSkuList: '', // ymsSkuList
        startCreatedTime: null, // 开始创建时间
        endCreatedTime: null, // 结束创建时间
        startDespatchTime: null,  // 开始发货时间
        endDespatchTime: null, // 结束发货时间
        startStorageTime: null, // 开始入库时间
        endStorageTime: null, // 结束入库时间
        startCancleTime: null, // 开始取消时间
        endCancleTime: null, // 结束取消时间
        pageNum: 1,
        pageSize: 15,
      },
      tableData: [],
      tableColumns: [],
      stockTabList: [
        {value: '0', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')},
        {value: '1', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002920')},
        {value: '2', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004327')},
        {value: '3', title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004557')}`},
        {value: '4', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001813')},
      ],
      stockOrderStatusList: [
        {value: 1, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002920')},
        {value: 2, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004327')},
        {value: 3, title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004557')}`},
        {value: 4, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001813')},
      ],
      deliveryOrderStatusList: [],
      exportType: '1',
      customFieldExportList: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000929'),
          titleKey: 'basicInfoColums',
          selectList: [], // 选中导出字段的key
          checkBoxList: [
            {paramKey: 'packageCode', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004559')},
            {paramKey: 'supplierMerchantId', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001098')},
            {paramKey: 'packageOrderStatus', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000461')},
            {paramKey: 'totalStockQuantity', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004428')},
            {paramKey: 'actualSortingQuantity', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004429')},
            {paramKey: 'pickupOrderNumber', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003658')},
            {paramKey: 'outPackageOrderStatus', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004371')},
            {paramKey: 'outboundType', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004560')},
            {paramKey: 'createdTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002159')},
            {paramKey: 'despatchTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004565')},
            {paramKey: 'storageTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003846')},
            {paramKey: 'rehandleTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004566')},
            {paramKey: 'warehouseId', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001342')},
          ]
        }
      ],
      printBarcodeList: [
        {name: '1', permissionKey: 'packageInfo_appendYmsSkuExpressBillStcok', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006850')},
        {name: '2', permissionKey: 'packageInfo_appendPackageInfoStockExpressBill', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006851')},
      ],
      apiUrl: api.put_wmsPickupOrder_printWmsPickupOrder,
      recordParams: {}, // 记录当前筛选条件的参数
      dropDownTimeList: [],
      defaultSelectTimeValue: 1,
      dropDownInputList: [ // 备货单号、SKU、YMSSKU
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004559'), value: 1, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004561'), parameterKey: 'packageCodeList'},
        {title: 'SKU', value: 2, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004114'), parameterKey: 'skuList'},
        {title: `${setConfigCharacters(false)}SKU`, value: 3, placeholder: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000324')}${setConfigCharacters(false)}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004558')}`, parameterKey: 'ymsSkuList'}
      ],
      defaultSelectValue: 1,
      countrysList: [],
      warehouseList: [],
      printUrl: api.post_packageInfo_appendPackageInfoOrderStockExpressBill,
      enumData: []
    }
  },
  computed: {
    filterKeyList() {
      return this.dropDownInputList.map((item) => {
        return item.parameterKey
      });
    },
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    // 出库单类型
    deliveryOrderTypeList() {
      const ENUM_KEY = 'PackageInfoOutboundTypeSupplierEnum';
      let list = getEnumList(this.enumData, ENUM_KEY, 'number');
      list = list.filter(item => [2, 3, 4].includes(item.value));
      return list;
    },
    // 出库状态
    outboundStatusList() {
      const ENUM_KEY = 'PackageInfoPackageProcessStatusSupplierEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number')
    }
  },
  created() {
    this.initData();
  },
  methods: {
    // 初始化数据
    async initData() {
      let enumKeyList = ['PackageInfoOutboundTypeSupplierEnum', 'PackageInfoPackageProcessStatusSupplierEnum'];
      this.enumData = await getDataSetBatchList(enumKeyList);
      this.countrysList = await getAllCountrysData('cn', true);
      this.handleStatusData(this.orderTableStatus);
      this.setDefaultTimerParams('three_months', 1);
      this.search();
    },
    // 重置数据
    reset() {
      let v = this;
      v.$refs['pageParams'].resetFields();
      v.changeInput(1);
      v.changeTimeInput(1);
      v.selectTableData = [];
      v.setDefaultTimerParams('three_months', 1);
      v.getList();
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.getList();
    },
    // 列表查询的方法
    getList() {
      let v = this;
      v.selectTableData = [];
      v.total = 0;
      v.tableData = [];
      v.optionBtnWidth = [];
      if (v.getPermission('packageInfo_queryForStock')) {
        v.tableLoading = true;
        v.axios.post(api.post_packageInfo_queryForStock, v.handleParameter()).then(response => {
          v.recordParams = v.handleParameter();
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              let list = data.list || [];
              const getCountryName = (countryCode) => {
                const found = v.countrysList.find(item => item.twoCode === countryCode);
                return found ? found.cnName : '-';
              };
              if (list.length > 0) {
                const warehouseIds = list.map(item => item.warehouseId).filter(Boolean);
                if (warehouseIds.length > 0) {
                  getAllWarehouseData({warehouseIds}).then((warehouseData) => {
                    v.warehouseList = warehouseData;
                    if (v.warehouseList.length) {
                      list.map((item) => {
                        const ele = v.warehouseList.find(ele => ele.ymsWarehouseId === item.warehouseId);
                        item.warehouseName = ele.name || '';
                        if (ele && ele.ymsWarehouseAddress) {
                          const address = {...ele.ymsWarehouseAddress[0]};
                          address.countryCodeName = getCountryName(address.countryCode);
                          item.warehouseAddress = address;
                        }
                      })
                    }
                    v.tableData = list;
                  });
                } else {
                  v.tableData = list;
                }
              }
              v.total = data.total;
            }
            v.$nextTick(() => {
              v.tableLoading = false;
            });
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 切换Tab
    changeTab(name) {
      let v = this;
      v.$refs['pageParams'].resetFields();
      v.changeInput(1);
      v.changeTimeInput(1);
      v.selectTableData = [];
      v.pageParams.packageOrderStatusList = name === '0' ? [] : [Number(name)];
      v.setDefaultTimerParams('three_months', 1);
      v.pageParams.pageNum = 1;
      v.pageParamsStatus = true;
    },
    // 勾选列表数据
    tableChange(data) {
      this.selectTableData = [];
      if (data) {
        this.selectTableData = data;
      }
    },
    // 批量发货
    bulkShipmentBtn(value) {
      let v = this;
      let pageParamsObj = {};
      let talg = true;
      if (value === '1') {
        if (v.selectTableData.length <= 0) {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006852'));
          talg = false;
        }
      } else {
        pageParamsObj = v.recordParams;
        if (v.tableData.length <= 0) {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006853'));
          talg = false;
        }
      }
      // 出库单状态：待发货  备货状态：，待发货可以操作执行发货
      let packageStatusTalg = v.selectTableData.every((item) => {
        return item.outPackageOrderStatus === 1
      })
      if (!packageStatusTalg) {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006854'));
        talg = false;
      }
      let packageOrderStatusTalg = v.selectTableData.every((item) => {
        return item.packageOrderStatus === 1
      })
      if (!packageOrderStatusTalg) {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006855'));
        talg = false;
      }
      talg = !!(packageOrderStatusTalg && packageStatusTalg);
      if (v.selectTableData.length > 0 && value === '1') {
        const firstWarehouseId = v.selectTableData[0].warehouseId;
        const allWarehouseIdSame = v.selectTableData.every(item => item.warehouseId === firstWarehouseId);
        if (!allWarehouseIdSame) {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006856'));
          talg = false;
        }
      }
      if (talg) {
        let shippingAddress = {};
        // 已选订单
        if (value === '1') {
          pageParamsObj = {
            batchDeliverType: 1,
            endCreatedTime: null,
            startCreatedTime: null,
            outPackageOrderStatusList: [],
            packageCodes: v.selectTableData.map((item) => {
              return item.packageCode
            }),
            packageOrderStatusList: [],
            outboundTypes: [1],
            skuList: [],
            pageNum: 1,
            pageSize: 100
          }
          shippingAddress = v.selectTableData[0].warehouseAddress;
        }
        // 筛选结果订单
        else {
          pageParamsObj = {
            ...v.recordParams,
            batchDeliverType: 2
          };
          shippingAddress = v.tableData[0].warehouseAddress;
        }
        v.$refs['logisticsInfo'].initLogisticsInfo(null, 'markShipment', pageParamsObj, shippingAddress);
      }
    },
    // 参数处理
    handleParameter() {
      let v = this;
      let params = Object.assign({}, v.pageParams);
      for (let key in params) {
        if (v.filterKeyList.includes(key)) {
          params[key] = v.sepCommasFn(params[key], [',', '，', '\n']);
        }
      }
      return params;
    },
    // 选择导出数据类型  1 按选中导出 2 按查询结果导出
    changeExportBtn(value) {
      this.exportType = value;
      if (value === '1') {
        if (this.selectTableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003077'));
          return false;
        }
      } else {
        if (this.tableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003078'));
          return false;
        }
      }
      this.$refs['exportFields'].getExportFieldsSetting();
    },
    // 导出数据
    exportFieldsDataBtn(obj) {
      let v = this;
      let query = v.handleParameter();
      if (v.exportType === '1') {
        query.packageIds = v.selectTableData.map((item) => {
          return item.packageId;
        });
      } else {
        query.packageIds = [];
      }
      v.$refs['exportFields'].saveExportFieldsSetting().then((data) => {
        if (data) {
          v.axios.post(api.post_packageInfo_exportPackageInfoStockOrder, query,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
            if (res.data.code === 0) {
              v.$refs['exportFields'].exportFieldsModal = false;
              let taskNumber = res.data.datas;
              setTimeout(() => {
                pageJump('/supplier.html#/exportTask?operateCode=' + taskNumber, '/yms-supplier-service', '_blank');
              }, 30)
            }
          });
        }
      });
    },
    // 打印配货清单
    printDistributionBtn() {
      let talg = this.tableData.length > 0 && this.selectTableData.length > 0;
      if (talg) {
        this.$refs['distributionListFormat'].initDistributionListFormat(this.selectTableData, 'stockList');
      } else {
        this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006857'));
        return false;
      }
    },
    // 重置勾选数据的状态
    updateSelect() {
      this.$refs['selection'].selectAll(false);
      this.selectTableData = [];
    },
    // 打印YMS条码
    printBarcodeBtn(value) {
      let v = this;
      let talg = true;
      if (value === '1') {
        this.$refs['scanOrderChange'].scanOrderChangeModal = true;
        this.$refs['scanOrderChange'].scanOrderType = 'stockList';
      } else {
        if (v.selectTableData.length <= 0) {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006858'));
          talg = false;
        } else {
          let outboundTypeTalg = v.selectTableData.every((item) => {
            return item.outboundType === 2
          });
          if (!outboundTypeTalg) {
            v.$Message.warning(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006848')}${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006849')}`);
            talg = false;
          }
        }
        if (v.tableData.length <= 0) {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006859'));
          talg = false;
        }
        if (talg) {
          let ymsSku = v.selectTableData[0]?.packageGoodsList[0]?.ymsSku
          let obj = {
            ...v.selectTableData[0],
            ymsSku: ymsSku
          }
          v.$refs['printPreviewWaybill'].initPrintPreviewWaybillData(obj, v.selectTableData);
        }
      }
    },
    // 更新
    updatePrint() {
      this.updateSelect();
    },
    // 操作批量发货之后，打印箱唛
    printBoxBtn(data) {
      this.$refs['printTalg'].getPrintData(data.wmsPickupOrderId)
    },
    // 获取选中的时间
    selectTime(data) {
      let v = this;
      let time = data.date;
      let timeList = v.defaultTimePeriod(time);
      let current = data.value;
      v.dropDownTimeList.map((item) => {
        if (item.value === current) {
          let startTimeKey = item.parameterKey[0];
          let endTimeKey = item.parameterKey[1];
          v.$nextTick(() => {
            v.$refs['dropDownDateTime'].timeList = v.defaultTimePeriod(time, false);
          });
          v.pageParams[startTimeKey] = v.$uDate.getUniversalTime(new Date(timeList[0]).getTime(), 'fulltime');
          v.pageParams[endTimeKey] = v.$uDate.getUniversalTime(new Date(timeList[1]).getTime(), 'fulltime');
        }
      });
    },
    // 改变默认时间筛选下拉选项的值
    changeTimeInput(value) {
      this.defaultSelectTimeValue = value;
      this.$refs['dropDownDateTime'].timeList = [];
      this.dropDownTimeList.map((item) => {
        let startTimeKey = item.parameterKey[0];
        let endTimeKey = item.parameterKey[1];
        this.pageParams[startTimeKey] = null;
        this.pageParams[endTimeKey] = null;
      });
    },
    // 重置选中的时间
    resetTime(value) {
      this.dropDownTimeList.map((item) => {
        if (item.value === value) {
          let startTimeKey = item.parameterKey[0];
          let endTimeKey = item.parameterKey[1];
          this.pageParams[startTimeKey] = null;
          this.pageParams[endTimeKey] = null;
        }
      });
    },
    // 获取下拉选项筛选条件的值
    updateInputValue(data) {
      this.pageParams[data.key] = data.value;
    },
    // 改变默认下拉选项的值
    changeInput(value) {
      this.defaultSelectValue = value;
      this.$refs.dropDownFilter.inputValue = '';
      this.dropDownInputList.map((item) => {
        if (Object.keys(this.pageParams).includes(item.parameterKey)) {
          this.pageParams[item.parameterKey] = '';
        }
      });
    },
    // 处理列表字段
    handleColumns(val) {
      let v = this;
      v.optionBtnWidth = [];
      let columns = [
        {
          type: 'selection',
          width: 60,
          fixed: 'left',
          key: 'idx',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004559'),
          key: 'packageCode',
          fixed: 'left',
          align: 'left',
          minWidth: 150,
          render(h, params) {
            return h('Alink', {
              props: {
                linkName: params.row.packageCode,
                styles: {
                  justifyContent: 'flex-start'
                }
              },
              on: {
                AlinkBtn: () => {
                  const {href} = v.$router.resolve({
                    path: '/stockOrderDetails',
                    query: {
                      packageId: params.row.packageId
                    }
                  });
                  window.open(href, '_blank');
                }
              }
            });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001098'),
          key: 'merchantId',
          align: 'left',
          minWidth: 130
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001342'),
          key: 'shippingWarehouse',
          minWidth: 170,
          align: 'left',
          render(h, params) {
            return h('span', getWarehouseName(v.warehouseList, params.row.warehouseId));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004562'),
          key: 'packageOrderStatus',
          align: 'left',
          minWidth: 140,
          render(h, params) {
            let text = '-';
            let orderStatus = params.row.packageOrderStatus;
            v.stockOrderStatusList.map((item) => {
              if (item.value === orderStatus) {
                text = item.title;
              }
            });
            return h('div', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004428'),
          key: 'totalStockQuantity',
          align: 'left',
          minWidth: 160
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004429'),
          key: 'actualSortingQuantity',
          align: 'left',
          minWidth: 160,
          render(h, params) {
            let actualSortingQuantity = params.row.actualSortingQuantity;
            let packageOrderStatus = params.row.packageOrderStatus; // 3 YMS已收货
            let text = packageOrderStatus === 3 ? actualSortingQuantity : '-';
            return h('span', text)
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003658'),
          key: 'pickupOrderNumber',
          align: 'left',
          minWidth: 160
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004371'),
          key: 'outPackageOrderStatus',
          align: 'left',
          minWidth: 120,
          render(h, params) {
            let text = '-';
            let outPackageOrderStatus = params.row.outPackageOrderStatus;
            v.deliveryOrderStatusList.map((item) => {
              if (item.value === outPackageOrderStatus) {
                text = item.title;
              }
            })
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004560'),
          key: 'outboundType',
          align: 'left',
          minWidth: 150,
          render(h, params) {
            let text = '-';
            let outboundType = params.row.outboundType;
            v.deliveryOrderTypeList.map((item) => {
              if (item.value === outboundType) {
                text = item.title;
              }
            });
            return outboundType === 4 ? h('div', {class: 'flex flex-align-center'}, [
              h('span', {class: 'mr4'}, text),
              h('Tooltip', {
                props: {
                  transfer: true,
                  maxWidth: 300,
                  content: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004171')}${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004172')}`
                },
              }, [
                h('Icon', {
                  props: {
                    type: 'md-help-circle',
                    size: 16
                  },
                  style: {
                    cursor: 'pointer'
                  }
                })
              ])
            ]) : h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002159'),
          key: 'createdTime',
          align: 'left',
          minWidth: 170,
          render(h, params) {
            return h('span', params.row.createdTime ? v.$uDate.dealTime(params.row.createdTime, 'fulltime') : '-');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004565'),
          key: 'despatchTime',
          align: 'left',
          minWidth: 170,
          render(h, params) {
            return h('span', params.row.despatchTime ? v.$uDate.dealTime(params.row.despatchTime, 'fulltime') : '-');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003846'),
          key: 'storageTime',
          align: 'left',
          minWidth: 170,
          render(h, params) {
            return h('span', params.row.storageTime ? v.$uDate.dealTime(params.row.storageTime, 'fulltime') : '-');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004566'),
          key: 'rehandleTime',
          align: 'left',
          minWidth: 170,
          render(h, params) {
            let orderStatus = params.row.orderStatus; // 5 供应商订单已取消
            if (['0', '4'].includes(v.orderTableStatus) && orderStatus === 5) {
              return h('span', params.row.rehandleTime ? v.$uDate.dealTime(params.row.rehandleTime, 'fulltime') : '-');
            } else {
              return h('span', '-');
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          width: 210,
          key: 'options',
          fixed: 'right',
          align: 'left',
          render(h, params) {
            let outboundType = params.row.outboundType;
            let packageId = params.row.packageId;
            let packageOrderStatus = params.row.packageOrderStatus;
            let outPackageOrderStatus = params.row.outPackageOrderStatus;
            return h('optsButtonList', {
              props: {
                operationList: [ // 备货单状态是待发货才可以修改数量
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006840'),
                    show: packageOrderStatus === 1 && v.getPermission('packageInfo_upatePackageGoodsQuantity'),
                    clickFn: () => {
                      v.$refs['modifyStockQuantity'].getModifyStockData(params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006860'),
                    show: [2, 3].includes(outboundType) && ![7, 8].includes(outPackageOrderStatus) &&
                      v.getPermission('packageInfo_obsoletePackageStock'),  // 云卖中心仓备货、三方仓备货且出库单状态是已装箱前都可以取消备货
                    clickFn: () => {
                      v.$Modal.confirm({
                        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006860'),
                        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006861'),
                        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006860'),
                        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
                        onOk: () => {
                          v.cancelStockingBtn(packageId);
                        },
                        onCancel: () => {
                        }
                      });
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ];
      // 0 全部、1 待发货、2 已发货、3 YMS已收货、4 已取消
      let newColumns = [];
      let hideKeyList = [];
      let obj = {
        '1': ['actualSortingQuantity', 'pickupOrderNumber', 'despatchTime', 'storageTime', 'updatedTime'],
        '2': ['actualSortingQuantity', 'storageTime', 'updatedTime'],
        '3': ['updatedTime'],
        '4': ['actualSortingQuantity', 'pickupOrderNumber', 'despatchTime', 'storageTime']
      }
      hideKeyList = obj[val] || [];
      newColumns = columns.filter((item) => {
        return !hideKeyList.includes(item.key)
      });
      v.tableColumns = newColumns;
    },
    // 取消备货
    cancelStockingBtn(packageId) {
      let v = this;
      let packageIds = [packageId];
      v.axios.put(api.post_packageInfo_obsoletePackageStock, packageIds, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
          v.pageParamsStatus = true;
        }
      });
    },
    // 处理状态数据
    handleStatusData(value) {
      // 出库状态
      this.deliveryOrderStatusList = [];
      this.dropDownTimeList = [];
      this.handleColumns(value);
      // 时间
      let timeList = [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002159'), value: 1, parameterKey: ['startCreatedTime', 'endCreatedTime']},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004565'), value: 2, parameterKey: ['startDespatchTime', 'endDespatchTime']},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003846'), value: 3, parameterKey: ['startStorageTime', 'endStorageTime']},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004566'), value: 4, parameterKey: ['startCancleTime', 'endCancleTime']},
      ];
      let values = {
        statusObj: {
          '0': [1, 2, 3, 4, 7, 8],
          '1': [1, 2, 3],
          '2': [8],
          '3': [4],
          '4': [7]
        },
        timeObj: {
          '0': [1, 2, 3, 4],
          '1': [1],
          '2': [1, 2],
          '3': [1, 2, 3],
          '4': [1, 4]
        }
      }
      this.outboundStatusList.map((item) => {
        if (values.statusObj[value]) {
          if (values.statusObj[value].includes(item.value)) {
            this.deliveryOrderStatusList.push(item);
          }
        }
      });
      timeList.map((item) => {
        if (values.timeObj[value]) {
          if (values.timeObj[value].includes(item.value)) {
            this.dropDownTimeList.push(item);
          }
        }
      });
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    },
    // 监听tab栏切换
    'orderTableStatus': {
      handler(value) {
        this.handleStatusData(value)
      },
      immediate: true,
      deep: true
    }
  },
  components: {
    printPreviewWaybillModal,
    dropDownDateTime,
    dropDownFilter,
    scanOrderChangeModal,
    exportFieldsModal,
    logisticsInfoModal,
    distributionListFormatModal,
    printCaseMarkModal,
    modifyStockQuantityModal,
    importBackupOrderModal
  }
}
</script>

<style scoped>

</style>
